
const maskText = function (text, options) {
  const offset = options.offset || 3
  const len = options.length || 4
  const mark = options.mark || '*'
  const replace = new Array(len).fill(mark).join('')

  text = text.split('')
  text.splice(offset, len, replace)
  text = text.join('')

  return text
}

export default function codeMask (text, options = {}) {
  // NOTE: JD - 支付页不进行代码掩码
  const airline = window.__MICRO_ROOT__?.airline
  const pagePath = window.location.pathname
  if (airline === 'JD' && pagePath.indexOf('/pay/v2/pay') >= 0) {
    return text
  }
  if (!text) {
    return text
  }

  const type = options.type || ''
  let codedText = text

  try {
    if (type === 'email') {
      const reg = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
      const matches = text.match(reg)
      let emailAfter = ''

      if (matches && matches.length) {
        codedText = matches[0].split('@')[0]
        emailAfter = matches[0].split('@')[1] // 邮箱后缀
        codedText = maskText(codedText, options)
        return `${codedText}@${emailAfter}`
      } else {
        return codedText
      }
    }

    codedText = maskText(codedText, options)
  } catch (e) {
    return codedText
  }

  return codedText
}
